import { Badge } from '../../Badge'
import { Counter } from '../../Counter'
import { Container } from '../Container'

import * as styles from './Badges.module.css'

function Badges() {
  return (
    <>
      <Container label='Badge, default, sizes - 6px, 8px'>
        <Badge className={styles.rightMargin} />
        <Badge size='medium' />
      </Container>
      <Container label='Badge, error, sizes - 6px, 8px'>
        <Badge className={styles.rightMargin} variant='error' />
        <Badge size='medium' variant='error' />
      </Container>
      <Container label='Counter, min, size - 16px'>
        <Counter count={5} />
      </Container>
      <Container label='Counter, min, error, size - 16px'>
        <Counter count={5} variant='error' />
      </Container>
      <Container label='Counter, size - 16px'>
        <Counter count={123} maxCount={200} />
      </Container>
      <Container label='Counter, error, size - 16px'>
        <Counter count={123} maxCount={200} variant='error' />
      </Container>
      <Container label='Counter, overflow, size - 16px'>
        <Counter count={555} maxCount={99} />
      </Container>
      <Container label='Counter, overflow, error, size - 16px'>
        <Counter count={555} maxCount={99} variant='error' />
      </Container>
      <Container label='Counter, overflow, table, size - 24px'>
        <Counter fixed count={2} variant='table' />
      </Container>
    </>
  )
}

export default Badges
